module.exports = __webpack_public_path__ + "media/images/icon__whatsapp@3x-f49b011cf29c89ebb397b041aecc1226.png";